import {
	Avatar,
	Box,
	Button,
	HStack,
	Modal,
	ScrollView,
	Text,
	useTheme,
	VStack,
} from "native-base";
import {  useNavigate } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import { API_URL } from "../../utils/env";
import { useEffect, useState } from "react";
import { DelegacionInterface } from "../../utils/interfaces/DelegacionInterface";
import { baseApi } from "../../utils/api";
import jwtDecode from "jwt-decode"
import RolesEnum from "../../utils/interfaces/RolesEnum"

function Centros() {
	const { colors } = useTheme();
	const navigate = useNavigate();
	const [removeCentroId, setRemoveCentroId] = useState(0);
	const [modalVisible, setModalVisible] = useState(false);
	const [delegacionList, setDelegacionList] = useState([]);
	const [search, setSearch] = useState('')
	const token = sessionStorage.getItem("token");
			let roles = [0];
			if(token){
				const {userData}:any = jwtDecode(token as string);
				roles= userData.userRole.map((v:any)=> v.role_id);
		}
		useEffect(() => {

      getDelegaciones()
    }, [search])
	const getDelegaciones = () => {
		let url = "user/get/centers";
		if(roles.includes(RolesEnum.Admin)){
			url = 'center/all'
		}
		baseApi
			.get(`${API_URL}/${url}${search === '' ? '' : `?search=${search}`}`,{
				headers: {
					"Authorization": "Bearer " + sessionStorage.getItem("token")
				}
			})
			.then((response) => {
				setDelegacionList(response.data);
			})
			.catch((error) => {
				console.log(error);
			});
	};
	const removeCentro = (id:any) => {
		baseApi
			.delete(`${API_URL}/center/delete/${id}`,{
				headers: {
					"Authorization": "Bearer " + sessionStorage.getItem("token")
				}
			})
			.then((response) => {
				// eslint-disable-next-line no-restricted-globals
				location.reload();
			})
			.catch((error) => {
				if(__DEV__){
				console.log(error);
			}
			});
	};
	useEffect(() => {
		getDelegaciones();
	}, []);
	function modalRemoveCentro() {
		return (
			<>
				<Modal
					style={{ height: "100%" }}
					isOpen={modalVisible}
					onClose={() => setModalVisible(false)}
				>
					<Modal.Content>
						<Modal.CloseButton />
						<Modal.Header>¿Desea eliminar el centro?</Modal.Header>
						{/* <Modal.Body>
							<ScrollView style={{ maxHeight: "500px" }}>
								
							</ScrollView>
						</Modal.Body> */}
						<Modal.Footer>
							<Button.Group space={2}>
								<Button
									variant="ghost"
									colorScheme="blueGray"
									onPress={() => {
										setModalVisible(false);
									}}
								>
									Cancelar
								</Button>
								<Button
									color={colors.red[500]}
									onPress={() => {
										removeCentro(removeCentroId);
									}}
								>
									Eliminar
								</Button>
							</Button.Group>
						</Modal.Footer>
					</Modal.Content>
				</Modal>
			</>
		);
	}
	return (
		<Wrapper title="Centros" subtitle="">
			<div className="page-wrapper">

				<div className="page-content">
				{modalRemoveCentro()}

					<div className="row">
						<div className="col-12">
							<div className="card">
								<div className="card-body">

									<div className="row align-items-center">
										<div className="col-lg-9 col-xl-10">
											<div className="float-lg-end">
												<div className="row row-cols-lg-2 row-cols-xl-auto g-2">
													<div className="col">
														<div className="position-relative">
															<input
																onChange={(e) => {
																setSearch(e.target.value)
																	e.preventDefault()
																}}
																type="text"
																className="form-control ps-5"
																placeholder="Buscar..."
																style={{ 
																	borderRadius: 4,
																	borderWidth: 2,
																	borderColor: '#000000',
																	padding: 8,
																	paddingLeft: 20,
																	paddingRight: 20,
																	backgroundColor: '#fff2a7',
																   }}
															/>{" "}
															<span className="position-absolute top-50 product-show translate-middle-y">
																<i className="bx bx-search"></i>
															</span>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="col-lg-3 col-xl-2">
											{token && (
												<Button 
												style={{
													backgroundColor: '#0d6efd',
													borderRadius: 4,
													padding: 8,
													paddingLeft: 32,
													paddingRight: 32,
												  }}
												  size={'md'}
												  _text={{
													color: '#fff',
													fontWeight: 'bold',
													fontSize: 16,
													marginBottom: 1,
												  }}
												onPress={() => navigate("/centros/crear")}>
												Crear
											</Button>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div style={{
						maxHeight: "800px",
						overflowY: "auto",
					}} className="row row-cols-1 row-cols-sm-2 row-cols-lg-4 row-cols-xl-3 row-cols-xxl-3 product-grid">

						{delegacionList.map((delegacion: DelegacionInterface, index) => (
							<div key={`${index}-${delegacion.id}`} className="col">
								<div className="card rounded-3">
									<div className="card-body">
										<img
											style={{ height: "200px",
											objectFit: "cover"
											 }}
											src={delegacion.image.url}
											className="card-img-top rounded-3"
											alt="..."
										/>
										<Box>
											<HStack alignItems="center" space={3}>
												<VStack width={"100%"}>
													<Text
														numberOfLines={1}
														fontSize={20}
														mt={3}
														fontWeight={"bold"}
														color="#0d6efd"
														_dark={{
															color: "primary.500",
														}}
													>
														{delegacion.name}
													</Text>
													<Text
														fontSize={18}
														color="coolGray.600"
														_dark={{
															color: "warmGray.200",
														}}
													>
														{delegacion.province.name}
													</Text>
												</VStack>
											</HStack>
											<HStack my={2} alignItems="center" space={3}>
												<Avatar
													size={"xs"}
													bg="green.500"
													source={{
														uri: delegacion.user.image.url,
													}}
												>
													AP
												</Avatar>
												<Text
													fontSize={18}
													color="coolGray.600"
													_dark={{
														color: "warmGray.200",
													}}
												>
													{delegacion.user.name}
												</Text>
											</HStack>
										</Box>


										<div className="product-content mt-3">
											<div className="d-flex align-items-center justify-content-between">
												<div className="">
													<p className="mb-0 product-short-name fw-bold fs-6 text-primary">Dirección:</p>
													<h6 className="mb-0 product-short-title">
														{delegacion.address}
													</h6>
												</div>
											</div>

											<div className="d-flex align-items-center justify-content-between mt-3">
												<div className="">
													<Box flexDir={"row"}>
														<h6
															style={{ color: colors.primary[500] }}
															className="mb-1 product-short-title  fw-bold fs-6 text-primary"
														>
															Total recursos:
														</h6>
														<h6 className="mb-1 product-short-title">{delegacion.resources_count}</h6>
													</Box>
													<Box flexDir={"row"}>
														<h6
															style={{ color: colors.primary[500] }}
															className="mb-0 product-short-title  fw-bold fs-6 text-primary"
														>
															Recursos en uso:
														</h6>
														<h6 className="mb-0 product-short-title">{delegacion.resources_active_count}</h6>
													</Box>
												</div>
											</div>
										</div>
										<div className=" my-3 d-flex justify-content-center">
											<Button
												startIcon={<i className="bx bxs-edit text-white fs-5"></i>}
												onPress={()=>{
													navigate(`/centros/editar/${delegacion.id}`)
												}}
												style={{
													backgroundColor: '#20c997',
													borderRadius: 4,
													padding: 4,
													paddingLeft: 24,
													paddingRight: 24,
													marginRight: 10,
												  }}
												  size={'md'}
												  _text={{
													color: '#fff',
													fontWeight: 'bold',
													fontSize: 16,
													marginBottom: 1,
												  }}
											>
												Editar
											</Button>
											{roles.includes(RolesEnum.Admin) && (
												<Button onPress={()=>{
												setRemoveCentroId(delegacion.id);
												setModalVisible(true);
											}} 
												startIcon={<i className="bx bxs-trash text-white fs-5"></i>}
												style={{
													backgroundColor: '#dc3545',
													borderRadius: 4,
													padding: 4,
													paddingLeft: 24,
													paddingRight: 24,
													marginRight: 10,
												  }}
												  size={'md'}
												  _text={{
													color: '#fff',
													fontWeight: 'bold',
													fontSize: 16,
													marginBottom: 1,
												  }}
											>
												Eliminar
											</Button>
											)}
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
					{/* <!--end row--> */}
				</div>
			</div>
		</Wrapper>
	);
}
export default Centros;
